"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupButton = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const StyledAnimations_1 = require("../../helpers/StyledAnimations");
const StyledFunctions_1 = require("../../helpers/StyledFunctions");
const styles_1 = require("../../styles");
const Flex_1 = tslib_1.__importStar(require("../Elements/Flex"));
const Button = (0, styled_components_1.default)('button') `
  position: relative;
  display: inline-flex;
  justify-content: ${props => (props.block ? 'center' : 'flex-start')};
  white-space: nowrap;
  align-items: center;
  user-select: none;
  border: 1px solid transparent;
  cursor: pointer;
  line-height: 1.5;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out,
    border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  ${props => props.block && 'width: 100%;'}
  ${props => props.loading && 'color: transparent !important;'}
  ${props => props.disabled && 'opacity: 0.5;'}
  ${Flex_1.getFlex}
  ${StyledFunctions_1.elementSize}
  ${StyledFunctions_1.elementType}
  ${StyledFunctions_1.getMargin}
  ${StyledFunctions_1.getPadding}
  ${props => props.minWidth && `min-width: ${props.minWidth}; justify-content: center;`}
  &:after {
    ${props => (props.loading ? 'display: block' : 'display: none')};
    position: absolute;
    content: '';
    top: calc(50% - (1.2em / 2));
    left: calc(50% - (1em / 2));
    width: 1em;
    height: 1em;
    border: 2px solid ${props => (props.light ? styles_1.Colors.Dark : styles_1.Colors.White)};
    border-top-color: transparent;
    border-right-color: transparent;
    animation: ${StyledAnimations_1.Rotate360} 500ms infinite linear;
    border-radius: 50%;
  }
  a {
    color: inherit;
    font-size: inherit;
    text-decoration: inherit;
    display: block;
  }
`;
Button.defaultProps = {
    type: 'button',
};
exports.GroupButton = (0, styled_components_1.default)(Flex_1.default) `
  & > * {
    border-radius: 0;
  }
  & > *:first-child {
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
  }
  & > *:last-child {
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
  }
`;
exports.default = Button;
